import { Component, EventEmitter, OnInit, Output, HostListener, ElementRef , ViewChild, TemplateRef} from '@angular/core';
import {NgbModal, ModalDismissReasons}   from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {HttpClient,HttpClientModule,HttpHeaders,} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApidataService } from '../apidata.service';
import { Router, Params, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.css'
})
export class LogoutComponent {
  constructor(private modalService: NgbModal,
    private router: Router,
    private apiservice: ApidataService,
     private http:HttpClient ,
    private elementRef: ElementRef,) {}
    doc_id = "";
  ngOnInit() {    
    this.openModal();
  }
  public ngAfterViewInit(): void {
  }
  @ViewChild('content', { static: true }) content: TemplateRef<any>;
  openModal() {    
    this.modalService.open(this.content,{ backdrop: 'static', keyboard: false , centered: true,windowClass: 'my-class'});
  }

openModels(content:any, data:any=null){
this.modalService.open(content,{size:"lg"})
}
closeModal(){
  this.modalService.dismissAll();
}
logout(){
  localStorage.clear()
  this.router.navigate([''])
  this.modalService.dismissAll();
}
}
